import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colorPallet } from '../../../styles/global';

export const Card = styled(Link)`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  text-decoration: none !important;
  pointer-events: ${(params) => (params.disabled ? 'none' : 'all')} !important;

  img {
    width: 100% !important;
    object-fit: cover !important;
    max-height: 210px !important;
    margin-bottom: 15px !important;
    transform: scale(100%) !important;
  }

  p {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: ${colorPallet.darkBlue} !important;
    text-align: left !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 3 !important;
    -webkit-box-orient: vertical !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    margin: 0 !important;

    @media screen and (max-width: 1366px) {
      font-size: 13px !important;
    }
  }
`;

export const Info = styled.div`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  margin-bottom: 10px !important;
  h1 {
    font-weight: 500 !important;
    font-size: 20px !important;
    color: ${colorPallet.darkBlue}!important;
    margin-bottom: 10px !important;
    text-align: left !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;

    @media screen and (max-width: 1366px) {
      font-size: 18px !important;
    }
  }
  p {
    font-size: 10px !important;
    font-weight: 500 !important;
    color: ${colorPallet.grey} !important;
  }
`;

export const Tag = styled.div`
  width: 60px !important;
  height: 23px !important;
  background: ${colorPallet.lightBlue} !important;
  align-self: start !important;
  margin-bottom: 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  p {
    color: ${colorPallet.darkBlue} !important;
    font-size: 10px !important;
    text-align: center !important;
    margin: 0 !important;
  }
`;

export const WrapperTags = styled.div`
display: flex;
gap: 5px;
`;
